import { IndicadoresCst, isCampoObrigatorio } from './indicadores-campos.util';

/**
 * Texto editorial do alerta do indicador de exigibilidade do ISS (indISS). Os campos que aparecem e são
 * exigidos vêm só do indicador do catálogo (`indicador_exigibilidade_iss.indicadores`, chave `nProcesso`);
 * o texto só descreve o que o indicador ligou.
 */
export interface IndicadorIssTexto {
    alertaTitulo: string;
    alertaTexto: string;
    alertaTipo: 'info' | 'warning' | 'success';
}

export function getIndicadorIssTexto(
    codigo: string | null | undefined,
    descricao: string | null | undefined,
    indicadores: IndicadoresCst,
): IndicadorIssTexto | null {
    if (!codigo) return null;
    const processoObrigatorio = isCampoObrigatorio(indicadores, 'nProcesso');

    return {
        alertaTitulo: `${codigo} - ${descricao || 'Indicador de exigibilidade'}`,
        alertaTexto: processoObrigatorio
            ? 'Exigibilidade suspensa: o Número do Processo é obrigatório para este indicador.'
            : 'Informe os dados do serviço aplicáveis a este indicador de exigibilidade do ISS.',
        alertaTipo: processoObrigatorio ? 'warning' : 'info',
    };
}
